/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconApple = createReactComponent("apple", "IconApple", [
  ["path", { d: "M12 14m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }],
  [
    "path",
    { d: "M12 11v-6a2 2 0 0 1 2 -2h2v1a2 2 0 0 1 -2 2h-2", key: "svg-1" }
  ],
  ["path", { d: "M10 10.5c1.333 .667 2.667 .667 4 0", key: "svg-2" }]
]);

export { IconApple as default };
//# sourceMappingURL=IconApple.js.map
